// ProfileLivestreamItem.js
import { connect } from 'react-redux';

import ProfileLivestreamItem from '../component/ProfileLivestreamItem.jsx';

import getOperationData from '../selector/getOperationData.js';

const mapStateToProps = (state, { sessionId }) => {
  return {
    startUnixTimestamp: getOperationData(
      state,
      ['me', 'livestream', sessionId],
      'startUnixTimestamp'
    ),
    endUnixTimestamp: getOperationData(
      state,
      ['me', 'livestream', sessionId],
      'endUnixTimestamp'
    ),
    summary: getOperationData(
      state,
      ['me', 'livestream', sessionId],
      'summary'
    ),
  };
};

export default connect(mapStateToProps, null)(ProfileLivestreamItem);
